import { AfterContentInit, ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SimpleListConfig } from 'src/app/models/simpleListConfig';
import { ManageAgreementService } from './manage-agreement.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'manage-agreement',
    templateUrl: './manage-agreement.component.html',
    styleUrls: ['./manage-agreement.component.scss'],
})
export class ManageAgreementComponent implements AfterContentInit {
    private readonly searchStorageKey = 'agreementExternalCollectorManageAgreementSearch';
    private _date: Date = new Date();
    initialDate: Date;
    endDate: Date;
    formSearch: FormGroup = new FormGroup({});
    loading: boolean = true;

    constructor(
        private fb: FormBuilder,
        private _manageAgreementService: ManageAgreementService,
        private router: Router,
        private spinner: NgxSpinnerService,
        private _cdRef: ChangeDetectorRef,
    ) {
        this.createForm();
        this.initialDate = new Date(this._date.getFullYear(), this._date.getMonth(), 1);
        this.endDate = new Date(this._date.getFullYear(), this._date.getMonth() + 1, 0);
        this.restoreSearchState();
        this.searchParams = {
            params: {
                status: this.formSearch.value.status,
                initialDate: this.initialDate.toJSON(),
                endDate: this.endDate.toJSON(),
                pageSize: this.configTable.page.size || this.configTable.pageSize[0],
                pageIndex: this.configTable.page.index,
            },
        };
        this.configTable.page.size = this.searchParams.params.pageSize;
    }

    showLoad(value: boolean) {
        this.loading = value;
        if (this.loading) {
            this.spinner.show();
        } else {
            this.spinner.hide();
        }
        this._cdRef.detectChanges();
    }

    disableRefresh: boolean = false;
    resOk: boolean = false;
    noData: boolean = true;
    data: any[] = [];

    statusObj: any = [
        { description: 'Todos', value: 0 },
        { description: 'Pendência', value: 1 },
        { description: 'Pago', value: 2 },
        { description: 'Falha', value: 3 },
        { description: 'Contabilizado', value: 4 },
    ];

    searchParams: {
        params: {
            status: number;
            initialDate: string;
            endDate: string;
            pageSize: any;
            pageIndex: number;
        };
    };

    createForm() {
        this.formSearch = this.fb.group({
            status: new FormControl(0),
            initialDate: new FormControl(''),
            endDate: new FormControl(''),
        });
    }

    private restoreSearchState(): void {
        const savedSearch = sessionStorage.getItem(this.searchStorageKey);
        if (!savedSearch) {
            return;
        }
        sessionStorage.removeItem(this.searchStorageKey);

        try {
            const state = JSON.parse(savedSearch);
            const initialDate = new Date(state.initialDate);
            const endDate = new Date(state.endDate);
            const pageSize = Number(state.pageSize);
            const pageIndex = Number(state.pageIndex);

            if (!isNaN(initialDate.getTime())) {
                this.initialDate = initialDate;
            }
            if (!isNaN(endDate.getTime())) {
                this.endDate = endDate;
            }

            this.formSearch.patchValue({
                status: state.status,
                initialDate: this.initialDate,
                endDate: this.endDate,
            });
            this.configTable.page.size = Number.isInteger(pageSize) && pageSize > 0 ? pageSize : 0;
            this.configTable.page.index = Number.isInteger(pageIndex) && pageIndex >= 0 ? pageIndex : 0;
        } catch {
            return;
        }
    }

    private saveSearchState(): void {
        sessionStorage.setItem(
            this.searchStorageKey,
            JSON.stringify({
                status: this.searchParams.params.status,
                initialDate: this.searchParams.params.initialDate,
                endDate: this.searchParams.params.endDate,
                pageSize: this.searchParams.params.pageSize,
                pageIndex: this.configTable.page.index,
            }),
        );
    }

    configTable: SimpleListConfig = {
        useSortable: true,
        useFilter: false,
        usePagination: false,
        pageSize: [15, 20, 30],
        dateformat: 'dd/MM/yyyy',
        displayColumns: [
            {
                displayName: 'Núm. Acerto',
                field: 'codigoAcerto',
            },
            {
                displayName: 'Entidade',
                field: 'codigoEntidade',
            },
            {
                displayName: 'Cobradora',
                field: 'companyName',
            },
            {
                displayName: 'Total do Acerto',
                field: 'valorTotal',
                type: 'currency',
                hideCurrencySymbol: true,
            },
            {
                displayName: 'Data',
                field: 'dataSolicitada',
                type: 'date',
            },
            {
                displayName: 'Status',
                field: 'status',
            },
            {
                field: 'action',
                type: 'action',
            },
        ],
        lineActions: [
            {
                action: (a) => this.onSelectToDetail(a),
                label: 'Detalhes',
                color: 'primary',
                icon: 'reorder',
            },
            {
                action: (a) => this.onDelete(a),
                label: 'Deletar',
                color: 'warn',
                icon: 'delete',
                disabled: (row: any) => row?.statusId !== 2 && row?.statusId !== 4,
            },
        ],
        page: {
            totalElements: 0,
            index: 0,
            size: 0,
        },
    };

    private onSelectToDetail(row: any): void {
        this.saveSearchState();
        this.router.navigate(['/agreement-external-collector/agreement-detail'], { state: { agreement: row } });
    }

    private onDelete(row: any): void {
        this._manageAgreementService.deleteAgreement(row.companyId, row.codigoAcerto).subscribe((res) => {
            if (res.status === 200) {
                this.submitForm();
            }
        });
    }

    ngAfterContentInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        this.disableRefresh = true;

        setTimeout(() => {
            this.disableRefresh = false;
        }, 20000);

        this.resOk = false;

        this.getListData(this.searchParams);
    }

    submitForm() {
        this.searchParams = {
            params: {
                status: this.formSearch.value.status,
                initialDate: this.initialDate.toJSON(),
                endDate: this.endDate.toJSON(),
                pageSize: this.configTable.pageSize[0],
                pageIndex: 0,
            },
        };
        this.configTable.page.index = 0;
        this.configTable.page.size = this.searchParams.params.pageSize;
        this.refreshComponent();
    }

    getListData(params: any) {
        this.showLoad(true);

        this._manageAgreementService.getAgreements(params).subscribe((res) => {
            const result = res?.data?.result ?? res?.result ?? [];

            this.data = result;
            const totalRecords = res?.data?.totalRecords ?? res?.totalRecords ?? result.length;
            this.configTable.page.totalElements = totalRecords;
            this.configTable.page.index = params?.params?.pageIndex ?? 0;
            this.configTable.page.size =
                params?.params?.pageSize ?? this.configTable.page.size ?? this.configTable.pageSize[0];

            if (totalRecords > this.configTable.pageSize[this.configTable.pageSize.length - 1]) {
                const index = this.configTable.pageSize.indexOf(totalRecords);

                if (index === -1) {
                    this.configTable.pageSize.push(totalRecords);
                }
            }

            this.resOk = true;
            this.noData = this.data.length > 0 ? false : true;
            this.showLoad(false);
            this._cdRef.detectChanges();
        });
    }

    reloadingForAction(ev) {
        this.resOk = false;
        this.searchParams.params.pageIndex = ev.pageIndex;
        this.searchParams.params.pageSize = ev.pageSize;
        this.configTable.page.size = ev.pageSize;
        this.configTable.page.index = ev.pageIndex;

        this.getListData(this.searchParams);
    }
}
